export async function getWpStorypage () {
  let acfUrl = `https://quell.staging.themoderati.com/wp-json/acf/v3/pages/988`
  const acfResponse = await fetch(acfUrl)
  const acf = await acfResponse.json() // This endpoint returns an array of 1 item, so return that item instead
  return {
    acf: acf.acf
  }
}

export async function getStory (slug) {
  let category = 9 // articles
  let url = `https://quell.staging.themoderati.com/wp-json/wp/v2/posts?slug=${slug}&_embed`

  const response = await fetch(url)
  const json = await response.json()

  // This endpoint returns an array of 1 item, so return that item instead
  return json[0]
}

export async function getAllStories () {
  let category = 9 // Stories
  let url = `https://quell.staging.themoderati.com/wp-json/wp/v2/posts?categories=${category}&_fields=slug&per_page=100`

  const response = await fetch(url)
  const json = await response.json()

  return json
}

export async function getSomeStories (pageNumber = 1) {
  let perPage = 8
  let category = 9 // Stories
  let url = `https://quell.staging.themoderati.com/wp-json/wp/v2/posts?page=${pageNumber}&per_page=${perPage}&categories=${category}&_embed`

  const response = await fetch(url)
  const maxPages = Math.ceil(response.headers.get('x-wp-total') / perPage)
  const json = await response.json()

  return {
    json,
    maxPages
  }
}
